import React, { createRef } from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import ENUMS from '../../../enums/index';
import * as introducedCafesActions from '../../../redux/introducedCafes/actions';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import Spin from '../../../components/loading';
import '../introducedCafes.scss';
import AlertAndConfirmation from '../../../utils/AlertAndConfirmation';
import { ChangeStatusButtons } from './changeStatusButtons';
class IntroducedCafeModal extends React.Component {
  constructor(props) {
    super(props);
    this.radio = createRef();
    this.textArea = createRef();
    this.state = {
      changedFlag: false,
    };
  }

  componentDidMount() {
    this.props.fetchIntroducedCafeDetails(this.props.introducedCafeId);
  }

  handleStatusSelect = () => {
    if (this.props.introducedCafeDetails.status === 'FIRST_REJECTION') {
      const selectedStatus = 'FINAL_REJECTION';
      this.setState({ status: selectedStatus, changedFlag: true });
    } else {
      const selectedStatus = 'FIRST_REJECTION';
      this.setState({ status: selectedStatus, changedFlag: true });
    }
  };

  handleAcceptStatus = (id) => {
    this.props
      .changeCafeStatus(
        'ACCEPTED_WITHOUT_CONTRACT',
        '',
        id,
      )
      .then(() => {
        this.props.closeModal();
        AlertAndConfirmation({
          title: locales('titles.editionsDoneSuccessfully'),
          text: '',
          type: 'success',
        });
      });
  };

  submitForm = event => {
    event.preventDefault();
    let { status } = this.state;
    if (
      status === 'REJECTED' ||
      status === 'FIRST_REJECTION' ||
      status === 'FINAL_REJECTION'
    ) {
      this.props
        .changeCafeStatus(
          status,
          this.textArea.current.value,
          this.props.introducedCafeId,
        )
        .then(() => {
          this.props.closeModal();
          AlertAndConfirmation({
            title: locales('titles.editionsDoneSuccessfully'),
            text: '',
            type: 'success',
          });
        });
    }
  };

  render() {
    let {
      loading,
      error,
      failed,
      changeStatusLoading,
      changeStatusMessage,
      changeStatusFailed,
      changeStatusError,
      message,
      introducedCafeDetails,
    } = this.props;
    let { status = introducedCafeDetails.status || 'WAITING' } = this.state;
    const currentStatus = this.props.introducedCafeDetails.status;
    return (
      <>
        <Modal id='introducedCafeModal' size='xl' isOpen={this.props.isOpen}>
          <ModalHeader className='col-12'>
            <div className='col-12 d-flex p-0'>
              <div className='col-5'>
                {locales('titles.cafeDetails', {
                  fieldName: introducedCafeDetails.cafeName,
                })}
              </div>
              <div className='col-7 d-flex justify-content-end p-0'>
                {this.state.changedFlag && (
                  <button
                    className='btn btn-success'
                    onClick={event => this.submitForm(event)}
                  >
                    <i className='fa fa-save' />
                    {locales('labels.save')}
                  </button>
                )}
                <button
                  onClick={() => this.props.closeModal()}
                  className='btn btn-light mx-1'
                >
                  <i className='fa fa-reply' />
                  {locales('labels.cancel')}
                </button>
              </div>
            </div>
          </ModalHeader>
          <ModalBody>
            <div className='col-12 d-flex justify-content-center align-items-center h-100'>
              <article className='col-12'>
                <Spin spinning={loading}>
                  <Spin spinning={changeStatusLoading}>
                    {error ? (
                      <div className='alert alert-danger'>
                        {locales('messages.server.error')}
                      </div>
                    ) : (
                      <>
                        {failed && (
                          <div className='alert alert-danger'>{message}</div>
                        )}
                        {changeStatusFailed && (
                          <div className='alert alert-danger'>
                            {changeStatusMessage}
                          </div>
                        )}
                        <div className='col-12'>
                          {/* city info part */}
                          <div className='col-12 p-0'>
                            <label className='text-primary font-weight-bold col-12 p-0'>
                              {locales('cafe.city.info')}
                            </label>
                            <div className='col-12 border rounded py-2 px-4'>
                              <div className='col-12 d-flex p-0'>
                                <div className='col-6 d-flex p-0'>
                                  <div className='col-6'>
                                    {locales('tables.cityName')}:
                                  </div>
                                  <div className='col-6 text-dark font-weight-bold'>
                                    {introducedCafeDetails.cafeCityName}
                                  </div>
                                </div>
                                <div className='col-6 d-flex p-0'>
                                  <div className='col-6'>
                                    {locales('messages.registrationFee')}:
                                  </div>
                                  <div className='col-10 d-flex text-dark font-weight-bold flex-wrap'>
                                    {introducedCafeDetails.registrationFee?.toLocaleString()}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* cafe info part */}
                          <div className='col-12 p-0 my-5'>
                            <label className='text-primary font-weight-bold col-12 p-0'>
                              {locales('labels.cafeInfo')}
                            </label>
                            <div className='col-12 border rounded py-2 px-4'>
                              <div className='col-12 d-flex p-0'>
                                <div className='col-6 d-flex p-0'>
                                  <div className='col-6'>
                                    {locales('fields.cafe.name')}:
                                  </div>
                                  <div className='col-6 text-dark font-weight-bold'>
                                    {introducedCafeDetails.cafeName}
                                  </div>
                                </div>
                                <div className='col-6 d-flex p-0'>
                                  <div className='col-6'>
                                    {locales('tables.cafePhoneNumber')}:
                                  </div>
                                  <div className='col-6 text-dark font-weight-bold'>
                                    {introducedCafeDetails.cafePhoneNumber}
                                  </div>
                                </div>
                              </div>

                              <div className='col-12 d-flex px-0 py-2'>
                                <div className='col-6 d-flex p-0'>
                                  <div className='col-6'>
                                    {locales('messages.cafeInstagram')}:
                                  </div>
                                  <div className='col-10 d-flex text-dark font-weight-bold flex-wrap'>
                                    {introducedCafeDetails.cafeInstagram}
                                  </div>
                                </div>

                                <div className='col-6 d-flex p-0'>
                                  <div className='col-6'>
                                    {locales('messages.cafeTableNumber')}:
                                  </div>
                                  <div className='col-10 d-flex text-dark font-weight-bold flex-wrap'>
                                    {introducedCafeDetails.cafeTableNumber}
                                  </div>
                                </div>
                              </div>

                              <div className='col-12 d-flex px-0 py-2'>
                                <div className='col-12 d-flex p-0'>
                                  <div className='col-2'>
                                    {locales('messages.address')}:
                                  </div>
                                  <div className='col-10 d-flex text-dark font-weight-bold flex-wrap'>
                                    {introducedCafeDetails.cafeAddress}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* introducer part */}
                          <div className='col-12 p-0 my-5'>
                            <label className='text-primary font-weight-bold col-12 p-0'>
                              {locales('titles.introducerInfo')}
                            </label>
                            <div className='col-12 border rounded py-2 px-4'>
                              <div className='col-12 d-flex p-0'>
                                <div className='col-6 d-flex p-0'>
                                  <div className='col-6'>
                                    {locales('modal.user.full.name')}:
                                  </div>
                                  <div className='col-6 text-dark font-weight-bold'>
                                    {introducedCafeDetails.introducerName}
                                  </div>
                                </div>
                                <div className='col-6'>
                                  {locales('labels.isCafeOwner')}؟
                                  <i
                                    className={`${
                                      introducedCafeDetails.isCafeOwner
                                        ? 'fal fa-vote-yea text-success font-weight-bold px-2 font-xlarge'
                                        : 'fal fa-vote-nay text-danger font-weight-bold px-2 font-xlarge'
                                    }`}
                                  />
                                </div>
                              </div>

                              <div className='col-12 d-flex p-0 py-2'>
                                <div className='col-6 d-flex p-0'>
                                  <div className='col-6'>
                                    {locales('modal.user.mobile.number')}:
                                  </div>
                                  <div className='col-6 text-dark font-weight-bold'>
                                    {
                                      introducedCafeDetails.introducerMobileNumber
                                    }
                                  </div>
                                </div>
                                <div className='col-6 d-flex p-0'>
                                  <div className='col-3'>
                                    {locales('messages.email')}:
                                  </div>
                                  <div className='col-9 text-dark font-weight-bold'>
                                    {
                                      introducedCafeDetails.introducerEmailAddress
                                    }
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* submitter part */}
                          <div className='col-12 p-0 my-5'>
                            <label className='text-primary font-weight-bold col-12 p-0'>
                              {locales('titles.submitterInfo')}
                            </label>
                            <div className='col-12 border rounded py-2 px-4'>
                              <div className='col-12 d-flex p-0'>
                                <div className='col-6 d-flex p-0'>
                                  <div className='col-6'>
                                    {locales('modal.user.full.name')}:
                                  </div>
                                  <div className='col-6 text-dark font-weight-bold'>
                                    {introducedCafeDetails.createdFullName}
                                  </div>
                                </div>
                                <div className='col-6 d-flex p-0'>
                                  <div className='col-6'>
                                    {locales('modal.user.mobile.number')}:
                                  </div>
                                  <div className='col-6 text-dark font-weight-bold'>
                                    {introducedCafeDetails.createdMobileNumber ||
                                      '---'}
                                  </div>
                                </div>
                              </div>

                              <div className='col-12 d-flex p-0 py-2'>
                                <div className='col-6 d-flex p-0'>
                                  <div className='col-6'>
                                    {locales('tables.creationDate')}:
                                  </div>
                                  <div className='col-6 text-dark font-weight-bold'>
                                    {introducedCafeDetails.createdAt}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* considerations part */}
                          <div className='col-12 p-0'>
                            <label className='text-primary font-weight-bold col-12 p-0'>
                              {locales('labels.considerations')}
                            </label>
                            <div className='col-12 border rounded py-2 px-4'>
                              <div className='col-12 d-flex p-0'>
                                <div className='col-6 d-flex p-0'>
                                  <div className='col-5'>
                                    {locales('tables.reviewDate')}:
                                  </div>
                                  <div className='col-7 text-dark font-weight-bold'>
                                    {introducedCafeDetails.reviewedAt || '---'}
                                  </div>
                                </div>
                                <div className='col-6 d-flex p-0'>
                                  <div className='col-6'>
                                    {locales('label.current.status')}:
                                  </div>
                                  <div
                                    className={`col-6 ${
                                      ENUMS.INTRODUCED_CAFE_STATUS.list.filter(
                                        (introducedCafe, index) =>
                                          introducedCafe.value ===
                                          (introducedCafeDetails.status ||
                                            'WAITING'),
                                      )[0].color
                                    } font-weight-bold`}
                                  >
                                    {
                                      ENUMS.INTRODUCED_CAFE_STATUS.list.filter(
                                        (introducedCafe, index) =>
                                          introducedCafe.value ===
                                          (introducedCafeDetails.status ||
                                            'WAITING'),
                                      )[0].title
                                    }
                                  </div>
                                </div>
                              </div>
                              <div className='col-12 d-flex p-0 py-2'>
                                <div className='col-2'>
                                  {locales('tables.reviewerFullName')}:
                                </div>
                                <div className='col-10 d-flex text-dark font-weight-bold flex-wrap'>
                                  {introducedCafeDetails.reviewerFullName ||
                                    '---'}
                                </div>
                              </div>
                              {introducedCafeDetails.reasonRejected &&
                                introducedCafeDetails.reasonRejected.length && (
                                  <div className='col-12 d-flex p-0 py-2'>
                                    <div className='col-2'>
                                      {locales('labels.rejectionReason')}:
                                    </div>
                                    <div className='col-10 d-flex text-dark font-weight-bold flex-wrap'>
                                      {introducedCafeDetails.reasonRejected}
                                    </div>
                                  </div>
                                )}
                            </div>
                          </div>

                          {/* Actions part */}
                          <div className='my-4 border rounded'>
                            <ChangeStatusButtons
                              id={this.props.introducedCafeDetails.id}
                              status={this.props.introducedCafeDetails.status}
                              handleStatusSelect={this.handleStatusSelect}
                              cafeCityCode={
                                this.props.introducedCafeDetails.cafeCityCode
                              }
                              hasRegistrationFee={
                                this.props.introducedCafeDetails
                                  .hasRegistrationFee
                              }
                              isPaidRegistrationFee={
                                this.props.introducedCafeDetails
                                  .isPaidRegistrationFee
                              }
                              handleAcceptStatus={this.handleAcceptStatus}
                            />
                            {currentStatus !== 'FINAL_REJECTION' &&
                              (status === 'FINAL_REJECTION' ||
                                status === 'FIRST_REJECTION') && (
                                <div className='col-12'>
                                  <textarea
                                    ref={this.textArea}
                                    placeholder={`${locales(
                                      'labels.rejectionReason',
                                    )}...`}
                                    className='my-3 form-control col-12'
                                  />
                                </div>
                              )}
                          </div>
                        </div>
                      </>
                    )}
                  </Spin>
                </Spin>
              </article>
            </div>
          </ModalBody>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = state => {
  console.log(state.introducedCafesReducer.introducedCafeDetails);
  return {
    loading: state.introducedCafesReducer.introducedCafeDetailsLoading,
    message: state.introducedCafesReducer.introducedCafeDetailsMessage,
    failed: state.introducedCafesReducer.introducedCafeDetailsFailed,
    error: state.introducedCafesReducer.introducedCafeDetailsError,
    introducedCafeDetails: state.introducedCafesReducer.introducedCafeDetails,

    changeStatusLoading:
      state.introducedCafesReducer.changeIntroducedCafeStatusLoading,
    changeStatusMessage:
      state.introducedCafesReducer.changeIntroducedCafeStatusMessage,
    changeStatusFailed:
      state.introducedCafesReducer.changeIntroducedCafeStatusFailed,
    changeStatusError:
      state.introducedCafesReducer.changeIntroducedCafeStatusError,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    fetchIntroducedCafeDetails: id =>
      dispatch(introducedCafesActions.fetchIntroducedCafeDetails(id)),
    changeCafeStatus: (status, rejectReason, cafeId) =>
      dispatch(
        introducedCafesActions.changeCafeStatus(status, rejectReason, cafeId),
      ),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(IntroducedCafeModal);
